import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export default function Footer() {
  const { content } = useContent();
  const contact = content?.contact || {};
  const services = content?.services || [];
  const sections = content?.sections || {};
  const tagline = sections.footer_tagline ||
    "Metal buildings, carports, fences, concrete, and welding — done right the first time by Hondo Castruita and crew.";
  const phone = contact.phone || "(254) 833-7563";
  const phoneLink = contact.phone_link || "+12548337563";
  const email = contact.email || "lcbuilders87@yahoo.com";
  const area = contact.area || "Central Texas";
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#F5F7FA] border-t border-[#E5E7EB] pt-20 pb-8 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-6">
            <div className="font-display uppercase text-6xl sm:text-7xl md:text-8xl leading-[0.85] tracking-tight text-[#0A0E1A]">
              LC Builders<br />
              <span className="text-[#4AB300]">LLC</span>
            </div>
            <p data-testid="footer-tagline" className="mt-6 text-[#4B5563] max-w-md leading-relaxed">
              {tagline}
            </p>
          </div>
          <div className="lg:col-span-3">
            <div className="font-display text-xs tracking-[0.3em] text-[#4AB300] mb-4">SERVICES</div>
            <ul className="space-y-3 text-[#374151]">
              {services.map((s) => (
                <li key={s.id || s.title}>{s.title}</li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <div className="font-display text-xs tracking-[0.3em] text-[#4AB300] mb-4">CONTACT</div>
            <ul className="space-y-4 text-[#1F2937]">
              <li>
                <a href={`tel:${phoneLink}`} className="flex items-start gap-3 hover:text-[#4AB300] transition-colors" data-testid="footer-phone">
                  <Phone size={16} className="mt-1 shrink-0" /> {phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${email}`} className="flex items-start gap-3 hover:text-[#4AB300] transition-colors break-all" data-testid="footer-email">
                  <Mail size={16} className="mt-1 shrink-0" /> {email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-1 shrink-0" /> {area}
              </li>
              {contact.facebook_url && contact.facebook_url.trim() && (
                <li>
                  <a
                    href={contact.facebook_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-facebook"
                    className="flex items-start gap-3 hover:text-[#1877F2] transition-colors"
                  >
                    <Facebook size={16} className="mt-1 shrink-0" /> Facebook
                  </a>
                </li>
              )}
              {contact.google_profile_url && contact.google_profile_url.trim() && (
                <li>
                  <a
                    href={contact.google_profile_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-google-profile"
                    className="flex items-start gap-3 hover:text-[#4AB300] transition-colors group"
                  >
                    <svg width="16" height="16" viewBox="0 0 48 48" className="mt-1 shrink-0" aria-hidden="true">
                      <path fill="currentColor" d="M43.6 20.5H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.1 8.1 3l5.7-5.7C34.9 6.1 29.7 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" opacity=".65"/>
                    </svg>
                    Google Business Profile
                  </a>
                </li>
              )}
              {contact.review_url && contact.review_url.trim() && (
                <li>
                  <a
                    href={contact.review_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-review-link"
                    className="inline-flex items-center gap-2 text-[#4AB300] hover:text-[#0A0E1A] transition-colors font-display uppercase tracking-widest text-xs pt-2"
                  >
                    Leave a Google Review →
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="border-t border-[#E5E7EB] pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[#6B7280] text-xs tracking-widest uppercase">
          <div>© {year} LC Builders LLC · All Rights Reserved</div>
          <div>
            Owner · Hondo Castruita ·
            <a href="/admin/login" className="ml-2 hover:text-[#4AB300]" data-testid="footer-admin-link">Admin</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
